import React, { useState } from 'react';
import { remittanceDialogSteps } from './Utils';
import KababMenuHorizontal from '../../BuildingBlocks/Menu/KababMenuHorizontal';
import RequestChangeDialog from './RequestPaymentChangeDialog';
import OtherOptionsDialog from './OtherOptionsDialog';

export default function Dialogs({
  payment,
  status,
  setLoading,
  setReviewPayment,
}) {
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [otherOptionsOpen, setOtherOptionsOpen] = useState(false);
  const [stepNumber, setStepNumber] = useState(
    remittanceDialogSteps.chooseOption,
  );
  const [disableEditButton, setDisableEditButton] = useState(() => {
    if (payment.payback === 0) return true;
    if (
      payment.paymentStatus === 'review' ||
      payment.paymentStatus === 'pending_customer_approval'
    ) {
      return true;
    }
    return !(status === 'Scheduled' || status === 'Queued');
  });

  const actions = [
    {
      name: 'Modify this Remittance',
      icon: './icons/edit.svg',
      onClick: () => {
        setStepNumber(remittanceDialogSteps.remittanceDetails);
        setPaymentDialogOpen(true);
      },
      color: 'black',
    },
    {
      name: 'Other Options',
      icon: './icons/otherOptions.svg',
      onClick: () => {
        setStepNumber(remittanceDialogSteps.chooseOption);

        setOtherOptionsOpen(true);
      },
      color: 'black',
    },
  ];

  return (
    <>
      <RequestChangeDialog
        setDisableEditButton={setDisableEditButton}
        paymentDialogOpen={paymentDialogOpen}
        setPaymentDialogOpen={setPaymentDialogOpen}
        stepNumber={stepNumber}
        setStepNumber={setStepNumber}
        payment={payment}
        setLoading={setLoading}
        setReviewPayment={setReviewPayment}
      />

      <OtherOptionsDialog
        stepNumber={stepNumber}
        setStepNumber={setStepNumber}
        otherOptionsOpen={otherOptionsOpen}
        setOtherOptionsOpen={setOtherOptionsOpen}
      />

      {!disableEditButton && (
        <KababMenuHorizontal actions={actions} disabled={disableEditButton} />
      )}
    </>
  );
}
